<template>
  <EventsPage />
</template>

<script setup>
import { useEventsStore } from '~/stores/events';
import { validateDate } from '~/utils/helpers/validators';
const { $cmsApi } = useNuxtApp();

useHead({
  title: 'Tech events & webinars – Proxify Careers',
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: 'Tech events & webinars – Proxify Careers',
    },
  ],
});

const eventsStore = useEventsStore();
const route = useRoute();

if (route.query.tag) {
  eventsStore.setTag(route.query.tag);
}

if (route.query.date) {
  const date = validateDate(route.query.date) ? route.query.date : null;

  eventsStore.setDate(date);
}

await useAsyncData(async () => {
  let libraryEvents = eventsStore.libraryEvents;
  let upcomingEvents = eventsStore.upcomingEvents;
  let mainEvent = eventsStore.mainEvent;
  let tags = eventsStore.tags;
  let eventDates = eventsStore.eventDates;

  if (!mainEvent) {
    mainEvent = await $cmsApi.get('/events/main');
    eventsStore.setMainEvent(mainEvent);
  }

  if (tags.length === 1) {
    tags = await $cmsApi.get('/events/tags');
    eventsStore.setTags(tags);
  }

  if (!eventDates.length) {
    eventDates = await $cmsApi.get('/events/event-dates');
    eventsStore.setEventDates(eventDates);
  }

  if (!upcomingEvents.length) {
    upcomingEvents = await $cmsApi.get(
      '/events/upcoming',
      eventsStore.filterParams
    );
    eventsStore.setUpcomingEvents(upcomingEvents);
  }

  if (!libraryEvents.length) {
    libraryEvents = await $cmsApi.get('/events/library', {
      ...eventsStore.filterParams,
      ...eventsStore.paginationParams,
    });
    eventsStore.setLibraryEvents(libraryEvents);
  }

  return { libraryEvents, upcomingEvents, mainEvent, tags, eventDates };
});
</script>
